import { useState } from "react";
import { fullMovies } from "@/mocks/home";

export default function MovieGrid() {
  const [liked, setLiked] = useState<Record<string, boolean>>({});

  const toggleLike = (id: string) => {
    setLiked((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <section id="movies" className="border-b border-background-200/70 bg-background-100/60">
      <div className="px-4 py-12 md:px-10 md:py-16">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="flex items-center gap-2 text-xs font-medium uppercase tracking-widest text-secondary-600">
              <i className="ri-stack-line text-base"></i>
              COLLECTION
            </div>
            <h2 className="mt-3 font-heading text-2xl font-semibold text-foreground-950 md:text-3xl">
              影片合集 · 电影与完整版
            </h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600">
              按封面进入对应版本，完整版、高清版与短片版都在这里，卡片上标注了时长与字幕状态。
            </p>
          </div>
          <a
            href="#shorts"
            className="flex w-fit cursor-pointer items-center gap-1.5 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
          >
            查看更多短片
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {fullMovies.map((movie) => (
            <article
              key={movie.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200/80 bg-background-50"
            >
              <div className="relative h-56 w-full overflow-hidden">
                <img
                  src={movie.cover}
                  alt={`${movie.title} 在线观看`}
                  title={`${movie.title} 中文字幕`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/55 via-transparent to-transparent"></div>

                <span className="absolute left-3 top-3 rounded-md bg-accent-500 px-2.5 py-1 text-[11px] font-medium text-accent-950">
                  {movie.version}
                </span>

                <button
                  type="button"
                  onClick={() => toggleLike(movie.id)}
                  aria-label="收藏"
                  className="absolute right-3 top-3 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-background-50/90 text-foreground-800 transition-colors hover:text-primary-600"
                >
                  <i className={liked[movie.id] ? "ri-heart-fill text-base text-primary-600" : "ri-heart-line text-base"}></i>
                </button>

                <span className="absolute bottom-3 left-3 flex items-center gap-1.5 rounded-md bg-background-50/90 px-2.5 py-1 text-[11px] font-medium text-foreground-900">
                  <i className="ri-time-line"></i>
                  {movie.duration}
                </span>
              </div>

              <div className="flex flex-1 flex-col p-4">
                <h3 className="font-heading text-base font-semibold text-foreground-950">
                  {movie.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                  {movie.desc}
                </p>

                <div className="mt-3 flex flex-wrap gap-1.5">
                  {movie.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] text-secondary-900"
                    >
                      {tag}
                    </span>
                  ))}
                </div>

                <div className="mt-auto flex items-center justify-between pt-4">
                  <span className="flex items-center gap-1.5 text-xs text-foreground-500">
                    <i className="ri-eye-line text-sm"></i>
                    {movie.heat}
                  </span>
                  <span className="flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-3 py-1.5 text-xs font-medium text-background-50 transition-colors group-hover:bg-primary-600">
                    <i className="ri-play-fill"></i>
                    播放
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}